module.exports = __webpack_public_path__ + "media/sofia/sofia_azul-96fde699.png";